import React from "react";
import { COLOR_CLASSES, SWATCH_CLASSES } from "../taskConstants";

// Renk anahtarı seçici (server paleti). Noktalar güçlü tonda (SWATCH_CLASSES); rozetler
// COLOR_CLASSES ile kalır. Tailwind sınıfları taskConstants'ta literal.
function ColorPalette({ value, onChange, disabled = false }) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Renk">
      {Object.keys(COLOR_CLASSES).map((key) => {
        const selected = value === key;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={key}
            title={key}
            disabled={disabled}
            onClick={() => onChange(key)}
            className={`w-7 h-7 rounded-full border-2 ${SWATCH_CLASSES[key]} ${
              selected ? "border-main ring-2 ring-main/30" : "border-transparent hover:border-gray-400"
            } disabled:opacity-50`}
          />
        );
      })}
    </div>
  );
}

export default ColorPalette;
